import { EntityNameModal } from '@/pages/admin/shared/entity-management/EntityNameModal';

type EditDepartmentModalProps = {
	isOpen: boolean;
	onClose: () => void;
	initialName: string;
	onSave: (name: string) => void;
};

export const EditDepartmentModal = ({
	isOpen,
	onClose,
	initialName,
	onSave,
}: EditDepartmentModalProps) => {
	return (
		<EntityNameModal
			isOpen={isOpen}
			onClose={onClose}
			title="Editar Departamento"
			description="Atualize o nome do departamento."
			label="NOME DO DEPARTAMENTO"
			placeholder="Ex: Recursos Humanos"
			submitText="Salvar alterações"
			inputId="edit-modal-dept-name"
			initialValue={initialName}
			onSubmitValue={onSave}
		/>
	);
};
